export default "__VITE_ASSET__f0325de4__"